import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHUnidadGet = async (credentials, data) => {
    const body = {
        service: "RNHUnidadGet",
        params: {
            rnhUnidadId: data?.id || null,
            rnhEstablecimientoId: data?.hospitalId || null,
            rnhDepartamentoId: data?.departamentoId || null,
            rnhDivisionId: data?.divisionId || null,
            soloDisponibles: data?.disponibles || ''
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
